import { useState, useRef } from "react";

// ─── CONEXIÓN BACKEND (Google Sheets vía Apps Script) ─────────────────────
const URL_APPS_SCRIPT = "https://script.google.com/macros/s/AKfycbzZqbnv-U0IjpXjq0PrOKTZmiSJac6Z1CQp1wLP6MFZFRigrzwLVrjY4jYqNgYLmU7Bkg/exec";
const TOKEN_SECRETO = "rly_8f3k2m9x_2026"; // debe coincidir con el del script de Apps Script

async function enviarLead(producto, data) {
  try {
    await fetch(URL_APPS_SCRIPT, {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=utf-8" }, // evita preflight CORS
      body: JSON.stringify({ token: TOKEN_SECRETO, producto, ...data }),
    });
    return true;
  } catch (e) {
    console.error("Error guardando lead:", e);
    // Guardamos en localStorage para no perder el lead si falla la conexión
    try {
      const pendientes = JSON.parse(localStorage.getItem("relayable_leads_pendientes")||"[]");
      pendientes.push({ producto, data, fecha: new Date().toISOString() });
      localStorage.setItem("relayable_leads_pendientes", JSON.stringify(pendientes));
    } catch {}
    return false;
  }
}

// ─── PALETA — identidad real Relayable (ocre / carbón / crema) ────────────
const C = {
  carbon:"#1C1A17", ocre:"#B8860B", ocreDark:"#9A7009", ocreLight:"#F7F0DC",
  green:"#2A7A52", greenLight:"#EBF5F0", greenDark:"#1E5A3C",
  amber:"#B8860B", amberLight:"#F7F0DC",
  red:"#C14F4F", redLight:"#F9EBEB",
  cream:"#FAF8F4", creamDark:"#EEE8DE",
  stone:"#7A776F", stoneLight:"#B0ADA5",
  border:"rgba(28,26,23,0.09)", borderMid:"rgba(28,26,23,0.15)",
  white:"#FFFFFF",
  // Alias de compatibilidad con el resto del código (no tocar nombres usados abajo)
  navy:"#1C1A17", navyLight:"#9A7009", navyDark:"#1C1A17",
  gray50:"#FAF8F4", gray100:"#EEE8DE", gray200:"rgba(28,26,23,0.15)",
  gray400:"#B0ADA5", gray500:"#7A776F", gray600:"#7A776F", gray800:"#1C1A17",
};
const FONT_DISPLAY = "'Playfair Display',Georgia,serif";
const FONT_BODY = "'DM Sans',system-ui,-apple-system,sans-serif";
const FONTS_LINK = "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=DM+Sans:wght@300;400;500;600;700&display=swap";

function CargarFuentes() {
  return (
    <link rel="stylesheet" href={FONTS_LINK} />
  );
}

// ─── BENCHMARKS ────────────────────────────────────────────────────────────
const BENCHMARKS = {
  hosteleria:{
    label:"Hostelería", icon:"☕",
    margenBruto:[55,70], multiplo:[1.5,3.0],
    precioRango:[15000,200000], variablePct:35,
    descripcionVar:"En hostelería los costes variables incluyen bebidas, alimentos, envases y mermas. Lo habitual es entre un 30–40% de las ventas.",
    alertas:["Contrato de alquiler: comprueba años restantes y condiciones de traspaso","Dependencia del dueño anterior: ¿los clientes son del local o de la persona?","Estado de cocina e instalaciones: revisión técnica antes de firmar","Licencias de actividad y terraza: verificar que están en vigor y son transferibles"],
  },
  comercio:{
    label:"Comercio / Retail", icon:"🛍️",
    margenBruto:[35,55], multiplo:[1.0,2.5],
    precioRango:[10000,120000], variablePct:55,
    descripcionVar:"En comercio los costes variables son principalmente el coste de la mercancía que vendes (precio de compra al proveedor). Suele ser el 45–60% de las ventas.",
    alertas:["Stock incluido: valorar qué porcentaje es realmente vendible","Tendencia de ventas: pedir datos de los últimos 24 meses, no solo el mejor año","Competencia online: analizar si el sector está siendo afectado por e-commerce","Contrato de alquiler: la ubicación es crítica en retail"],
  },
  servicios:{
    label:"Servicios", icon:"💼",
    margenBruto:[50,75], multiplo:[1.5,4.0],
    precioRango:[8000,150000], variablePct:20,
    descripcionVar:"En servicios los costes variables son bajos — principalmente materiales consumibles, subcontrataciones puntuales y comisiones comerciales. Suele ser un 15–25% de las ventas.",
    alertas:["Cartera de clientes: ¿hay contratos firmados o solo relaciones personales?","Dependencia del fundador: ¿los clientes seguirán con el nuevo propietario?","Activos intangibles: marca, reputación online, posicionamiento SEO"],
  },
  salud:{
    label:"Salud / Estética", icon:"🏥",
    margenBruto:[55,72], multiplo:[1.5,3.5],
    precioRango:[20000,250000], variablePct:25,
    descripcionVar:"En salud y estética los costes variables incluyen materiales, productos cosméticos, fungibles médicos y comisiones a profesionales externos. Suele ser un 20–30%.",
    alertas:["Licencias sanitarias: verificar que son transferibles o renovables","Cartera de pacientes/clientes: confidencialidad y RGPD en la cesión de datos","Equipos: estado, calibraciones y coste de mantenimiento o sustitución"],
  },
  industria:{
    label:"Industria / Taller", icon:"🔧",
    margenBruto:[35,55], multiplo:[1.0,2.5],
    precioRango:[20000,300000], variablePct:45,
    descripcionVar:"En industria y talleres los costes variables incluyen materias primas, componentes, energía ligada a producción y subcontrataciones. Suele ser un 40–50%.",
    alertas:["Maquinaria: estado, antigüedad y coste de reposición","Cartera de clientes: concentración en pocos clientes es riesgo alto","Permisos medioambientales y de actividad: verificar vigencia"],
  },
  otro:{
    label:"Otro sector", icon:"📦",
    margenBruto:[40,65], multiplo:[1.0,3.0],
    precioRango:[5000,200000], variablePct:35,
    descripcionVar:"Los costes variables son todos aquellos que crecen directamente con tus ventas: materias primas, mercancía, comisiones, envíos, etc.",
    alertas:["Verificar licencias y permisos de actividad","Analizar tendencia de ventas de los últimos 24 meses","Comprobar estado de contratos con clientes y proveedores"],
  },
};

// ─── CONTACTO RELAYABLE ────────────────────────────────────────────────────
const WHATSAPP_NUMERO = "34690107026";
const WEB_CONTACTO = "https://www.relayable.es/#contacto";
const WEB_HOME = "https://www.relayable.es/";
const URL_PRIVACIDAD = "https://www.relayable.es/politica-de-privacidad";

function urlWhatsapp(mensaje) {
  return `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(mensaje)}`;
}

const N = v => Number(v)||0;
const fmt = n => (n===undefined||n===null||isNaN(n)) ? "—"
  : new Intl.NumberFormat("es-ES",{style:"currency",currency:"EUR",maximumFractionDigits:0}).format(n);
const fmtPct = n => isNaN(n) ? "—" : `${Number(n).toFixed(1)}%`;
const fmtMes = n => (!isFinite(n)||n<=0) ? "—" : n<12 ? `${Math.round(n)} meses` : `${(n/12).toFixed(1)} años`;

// ─── CÁLCULO ───────────────────────────────────────────────────────────────
function calcular(data) {
  const bench = BENCHMARKS[data.sector]||BENCHMARKS.otro;
  const ing = data.lineasIngreso.reduce((s,l)=>s+N(l.importe),0);
  const pctVar = N(data.pctVar)/100;
  const cv = ing*pctVar;
  const margenBruto = ing>0 ? (ing-cv)/ing*100 : 0;

  const cuota = (() => {
    const P=N(data.prestamo), r=N(data.interes)/100/12, n=N(data.años)*12;
    if(!P) return 0;
    if(!r) return P/n;
    return P*r*Math.pow(1+r,n)/(Math.pow(1+r,n)-1);
  })();

  const cfijos = N(data.alquiler)+N(data.personal)+N(data.suministros)
    +N(data.gestoria)+N(data.otrosFijos)
    +N(data.segurosAnual)/12+N(data.otrosAnual)/12
    +N(data.retribucion)+N(data.cuotaAutonomo)+cuota;

  const beneficioMes = ing-cv-cfijos;
  const margenNeto = ing>0 ? beneficioMes/ing*100 : 0;
  const puntoEq = pctVar<1 ? cfijos/(1-pctVar) : 0;
  const margenSeguridad = ing-puntoEq;
  const mesesRec = beneficioMes>0 ? (N(data.precio)+N(data.gastos))/beneficioMes : Infinity;
  const multiplo = ing>0 ? (N(data.precio)+N(data.gastos))/(ing*12) : 0;

  const pesimista = { ing:ing*0.8, ben:ing*0.8*(1-pctVar)-cfijos };
  const optimista = { ing:ing*1.2, ben:ing*1.2*(1-pctVar)-cfijos };

  // Semáforo
  let puntos = 0;
  if(beneficioMes>0) puntos+=2;
  if(margenBruto>=bench.margenBruto[0]) puntos+=1;
  if(margenNeto>=5) puntos+=1;
  if(data.perfil==="traspaso"&&multiplo>0&&multiplo<=bench.multiplo[1]) puntos+=1;
  if(data.perfil==="traspaso"&&mesesRec<48) puntos+=1;
  if(pesimista.ben>0) puntos+=1;

  const semaforo = puntos>=6?"verde":puntos>=4?"ambar":"rojo";

  const razones = [];
  if(beneficioMes>0) razones.push(`El negocio genera un beneficio estimado de ${fmt(beneficioMes)}/mes en el escenario base.`);
  else razones.push(`En el escenario base el negocio no cubre costes — faltan ${fmt(Math.abs(beneficioMes))}/mes.`);
  if(margenBruto<bench.margenBruto[0]) razones.push(`El margen bruto (${fmtPct(margenBruto)}) está por debajo de lo habitual en ${bench.label} (${bench.margenBruto[0]}–${bench.margenBruto[1]}%).`);
  else razones.push(`El margen bruto (${fmtPct(margenBruto)}) está dentro del rango habitual del sector.`);
  if(data.perfil==="traspaso"&&multiplo>0) {
    if(multiplo>bench.multiplo[1]) razones.push(`El múltiplo de valoración (${multiplo.toFixed(1)}x) está por encima del rango del sector (${bench.multiplo[0]}–${bench.multiplo[1]}x). El precio puede ser elevado.`);
    else razones.push(`El múltiplo de valoración (${multiplo.toFixed(1)}x) está dentro del rango del sector.`);
  }
  if(pesimista.ben<0) razones.push(`En el escenario pesimista (−20% ventas) el negocio entra en pérdidas. Revisa el margen de seguridad.`);
  else razones.push(`Incluso con un 20% menos de ventas el negocio seguiría siendo rentable.`);

  return {semaforo,razones,beneficioMes,margenBruto,margenNeto,puntoEq,margenSeguridad,cfijos,cv,ing,cuota,mesesRec,multiplo,pesimista,optimista,bench};
}

// ─── COMPONENTES BASE ──────────────────────────────────────────────────────
function Btn({children,onClick,variant="primary",disabled,small}) {
  const bg = {primary:C.ocre,secondary:C.white,green:C.green};
  const col = {primary:C.white,secondary:C.carbon,green:C.white};
  const brd = {primary:"none",secondary:`1.5px solid ${C.borderMid}`,green:"none"};
  return (
    <button onClick={onClick} disabled={disabled}
      style={{background:bg[variant],color:col[variant],border:brd[variant],
        padding:small?"9px 18px":"13px 24px",borderRadius:9,
        fontSize:small?13:14,fontWeight:500,fontFamily:FONT_BODY,
        cursor:disabled?"not-allowed":"pointer",
        opacity:disabled?0.45:1,width:"100%",
        transition:"opacity 0.15s,background 0.15s"}}
      onMouseEnter={e=>{if(!disabled)e.currentTarget.style.background=variant==="primary"?C.ocreDark:variant==="secondary"?C.creamDark:e.currentTarget.style.background}}
      onMouseLeave={e=>{e.currentTarget.style.background=bg[variant]}}>
      {children}
    </button>
  );
}

function Campo({label,hint,tooltip,children}) {
  const [showTip,setShowTip] = useState(false);
  return (
    <div style={{marginBottom:16}}>
      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:hint?2:5}}>
        <label style={{fontSize:13,fontWeight:500,color:C.carbon,fontFamily:FONT_BODY}}>{label}</label>
        {tooltip&&(
          <button type="button" onClick={()=>setShowTip(!showTip)}
            style={{width:18,height:18,borderRadius:"50%",background:showTip?C.carbon:C.ocre,color:C.white,
              fontSize:11,fontWeight:600,display:"inline-flex",alignItems:"center",
              justifyContent:"center",cursor:"pointer",flexShrink:0,border:"none",padding:0,
              transition:"background 0.15s"}}>
            {showTip?"✕":"?"}
          </button>
        )}
      </div>
      {tooltip&&showTip&&(
        <div style={{background:C.cream,border:`1px solid ${C.borderMid}`,borderRadius:8,
          padding:"10px 12px",marginBottom:10,fontSize:12,lineHeight:1.55,color:C.carbon}}>
          <p style={{margin:0}}>{tooltip}</p>
          <p style={{margin:"8px 0 0",paddingTop:8,borderTop:`1px solid ${C.borderMid}`,
            color:C.stone,fontSize:11,fontWeight:300,fontStyle:"italic"}}>
            Si no estás seguro, pon tu mejor estimación — podrás ajustarlo más adelante.
          </p>
        </div>
      )}
      {hint&&<p style={{fontSize:11,color:C.stone,margin:"0 0 5px",lineHeight:1.4,fontWeight:300}}>{hint}</p>}
      {children}
    </div>
  );
}

function InputNum({value,onChange,prefix,suffix,placeholder}) {
  return (
    <div style={{position:"relative",display:"flex",alignItems:"center"}}>
      {prefix&&<span style={{position:"absolute",left:11,fontSize:13,color:C.stoneLight,pointerEvents:"none"}}>{prefix}</span>}
      <input type="number" value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder||"0"}
        style={{width:"100%",padding:"10px 12px",paddingLeft:prefix?26:12,paddingRight:suffix?36:12,
          border:`1.5px solid ${C.borderMid}`,borderRadius:8,fontSize:14,color:C.carbon,
          outline:"none",boxSizing:"border-box",fontFamily:FONT_BODY,background:C.white}}
        onFocus={e=>e.target.style.borderColor=C.ocre}
        onBlur={e=>e.target.style.borderColor=C.borderMid}/>
      {suffix&&<span style={{position:"absolute",right:11,fontSize:12,color:C.stoneLight,pointerEvents:"none"}}>{suffix}</span>}
    </div>
  );
}

function SelectCards({options,value,onChange,cols}) {
  const n = cols||Math.min(options.length,3);
  return (
    <div style={{display:"grid",gridTemplateColumns:`repeat(${n},1fr)`,gap:8}}>
      {options.map(opt=>(
        <button key={opt.value} onClick={()=>onChange(opt.value)}
          style={{padding:"11px 8px",border:`2px solid ${value===opt.value?C.ocre:C.borderMid}`,
            borderRadius:10,background:value===opt.value?C.ocreLight:C.white,
            cursor:"pointer",textAlign:"center",outline:"none",fontFamily:FONT_BODY,transition:"all 0.15s"}}>
          {opt.icon&&<div style={{fontSize:20,marginBottom:3}}>{opt.icon}</div>}
          <div style={{fontSize:12,fontWeight:500,color:value===opt.value?C.ocreDark:C.stone}}>{opt.label}</div>
          {opt.sub&&<div style={{fontSize:10,color:C.stoneLight,marginTop:2,lineHeight:1.3,fontWeight:300}}>{opt.sub}</div>}
        </button>
      ))}
    </div>
  );
}

function Alerta({tipo="info",children}) {
  const col = {
    info:{bg:"#F2F0EC",br:C.stoneLight,tx:C.carbon},
    warn:{bg:C.amberLight,br:C.amber,tx:C.ocreDark},
    ok:{bg:C.greenLight,br:C.green,tx:C.greenDark},
    danger:{bg:C.redLight,br:C.red,tx:"#8B3A3A"},
  }[tipo];
  return (
    <div style={{background:col.bg,border:`1px solid ${col.br}`,borderRadius:8,
      padding:"9px 13px",fontSize:12,color:col.tx,marginBottom:12,lineHeight:1.5,fontWeight:300}}>
      {children}
    </div>
  );
}

function BarraProgreso({step,total}) {
  const labels = ["Bienvenida","Tu perfil","El negocio","Inversión","Ingresos y costes","Casi listo"];
  return (
    <div style={{marginBottom:24}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
        <span style={{fontSize:12,fontWeight:500,color:C.carbon}}>{labels[step]||""}</span>
        <span style={{fontSize:12,color:C.stoneLight}}>Paso {step} de {total}</span>
      </div>
      <div style={{height:4,background:C.creamDark,borderRadius:4,overflow:"hidden"}}>
        <div style={{height:"100%",width:`${(step/total)*100}%`,
          background:C.ocre,
          borderRadius:4,transition:"width 0.4s ease"}}/>
      </div>
    </div>
  );
}

function MetricCard({label,value,sub,highlight,color}) {
  return (
    <div style={{background:highlight?C.greenLight:C.cream,
      border:`1px solid ${highlight?C.green:C.borderMid}`,
      borderRadius:10,padding:"12px 14px",textAlign:"center"}}>
      <div style={{fontSize:18,fontWeight:500,fontFamily:FONT_DISPLAY,color:color||(highlight?C.greenDark:C.carbon),marginBottom:2}}>{value}</div>
      <div style={{fontSize:11,color:C.stone,lineHeight:1.3,fontWeight:300}}>{label}</div>
      {sub&&<div style={{fontSize:10,color:C.stoneLight,marginTop:3,fontWeight:300}}>{sub}</div>}
    </div>
  );
}

function Semaforo({estado,animating}) {
  const color = estado==="verde"?C.green:estado==="ambar"?C.amber:C.red;
  const label = estado==="verde"?"Viable":estado==="ambar"?"Viable con condiciones":"Requiere revisión";
  return (
    <div style={{textAlign:"center",padding:"16px 0 8px"}}>
      <div style={{width:76,height:76,borderRadius:"50%",
        background:animating?C.creamDark:color,
        transition:"background 0.8s ease",
        boxShadow:animating?"none":`0 0 0 8px ${color}22,0 0 0 16px ${color}11`,
        margin:"0 auto 10px",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <span style={{fontSize:30}}>{animating?"⏳":estado==="verde"?"✓":estado==="ambar"?"!":"✕"}</span>
      </div>
      <div style={{fontSize:18,fontWeight:500,fontFamily:FONT_DISPLAY,color:animating?C.stoneLight:color,transition:"color 0.8s"}}>
        {animating?"Calculando tu diagnóstico...":label}
      </div>
    </div>
  );
}

// ─── PANTALLA 0: BIENVENIDA ────────────────────────────────────────────────
function StepLanding({onElegir}) {
  return (
    <div>
      <div style={{textAlign:"center",marginBottom:8}}>
        <span style={{display:"inline-flex",alignItems:"center",gap:7,fontSize:11,color:C.stone,
          background:C.white,border:`1px solid ${C.borderMid}`,padding:"5px 14px",borderRadius:20,marginBottom:18}}>
          <span style={{width:5,height:5,borderRadius:"50%",background:C.ocre,display:"inline-block"}}/>
          Simulador gratuito · Sin compromiso
        </span>
        <h1 style={{fontFamily:FONT_DISPLAY,fontSize:26,fontWeight:400,lineHeight:1.25,color:C.carbon,margin:"0 0 12px"}}>
          Antes de dar el paso, <em style={{color:C.ocre,fontStyle:"italic"}}>haz números</em>
        </h1>
        <p style={{fontSize:13,fontWeight:300,color:C.stone,lineHeight:1.7,margin:"0 auto 28px",maxWidth:380}}>
          Relayable conecta a quien quiere comprar un negocio con quien quiere venderlo.
          Empieza por aquí — dinos qué estás buscando.
        </p>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr",gap:12,marginBottom:18}}>
        <button onClick={()=>onElegir("comprador")}
          style={{background:C.white,border:`1.5px solid ${C.borderMid}`,borderRadius:14,
            padding:"20px 22px",cursor:"pointer",textAlign:"left",fontFamily:FONT_BODY,
            transition:"border-color 0.15s"}}
          onMouseEnter={e=>e.currentTarget.style.borderColor=C.ocre}
          onMouseLeave={e=>e.currentTarget.style.borderColor=C.borderMid}>
          <div style={{display:"flex",alignItems:"flex-start",gap:14}}>
            <div style={{width:42,height:42,borderRadius:"50%",background:C.ocreLight,
              display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>🏪</div>
            <div>
              <h3 style={{fontFamily:FONT_DISPLAY,fontSize:16,fontWeight:400,color:C.carbon,margin:"0 0 6px"}}>
                ¿Piensas emprender o comprar un negocio?
              </h3>
              <p style={{fontSize:12,fontWeight:300,color:C.stone,lineHeight:1.6,margin:"0 0 10px"}}>
                Descubre si es buena idea con tus propios números — beneficio real, punto de equilibrio y si el precio que te piden tiene sentido.
              </p>
              <span style={{fontSize:12,color:C.ocreDark,fontWeight:500}}>Quiero saber si es viable →</span>
            </div>
          </div>
        </button>

        <button onClick={()=>onElegir("vendedor")}
          style={{background:C.white,border:`1.5px solid ${C.borderMid}`,borderRadius:14,
            padding:"20px 22px",cursor:"pointer",textAlign:"left",fontFamily:FONT_BODY,
            transition:"border-color 0.15s"}}
          onMouseEnter={e=>e.currentTarget.style.borderColor=C.green}
          onMouseLeave={e=>e.currentTarget.style.borderColor=C.borderMid}>
          <div style={{display:"flex",alignItems:"flex-start",gap:14}}>
            <div style={{width:42,height:42,borderRadius:"50%",background:C.greenLight,
              display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>🏷️</div>
            <div>
              <h3 style={{fontFamily:FONT_DISPLAY,fontSize:16,fontWeight:400,color:C.carbon,margin:"0 0 6px"}}>
                ¿Piensas vender tu negocio?
              </h3>
              <p style={{fontSize:12,fontWeight:300,color:C.stone,lineHeight:1.6,margin:"0 0 10px"}}>
                Obtén un rango de valoración orientativo basado en tus cifras reales — y argumentos para defender el precio ante un comprador.
              </p>
              <span style={{fontSize:12,color:C.greenDark,fontWeight:500}}>Quiero valorar mi negocio →</span>
            </div>
          </div>
        </button>
      </div>

      <div style={{textAlign:"center"}}>
        <p style={{fontSize:11,color:C.stoneLight,margin:"0 0 6px"}}>¿No sabes por dónde empezar o tienes dudas?</p>
        <a href={WEB_CONTACTO} target="_blank" rel="noopener noreferrer"
          style={{fontSize:11,color:C.stone,textDecoration:"underline"}}>
          Habla con nosotros
        </a>
      </div>
    </div>
  );
}

function StepVendedorProximamente({onVolver}) {
  return (
    <div style={{textAlign:"center",padding:"20px 0"}}>
      <div style={{fontSize:36,marginBottom:14}}>🏷️</div>
      <h2 style={{fontFamily:FONT_DISPLAY,fontSize:20,fontWeight:400,color:C.carbon,margin:"0 0 10px"}}>
        Muy pronto
      </h2>
      <p style={{fontSize:13,fontWeight:300,color:C.stone,lineHeight:1.6,margin:"0 auto 24px",maxWidth:340}}>
        Estamos terminando la calculadora de valoración para vendedores. Mientras tanto, escríbenos y te ayudamos directamente con tu caso.
      </p>
      <div style={{display:"grid",gridTemplateColumns:"1fr",gap:8,maxWidth:280,margin:"0 auto"}}>
        <a href={urlWhatsapp("Hola, quiero saber cuánto vale mi negocio")} target="_blank" rel="noopener noreferrer"
          style={{display:"block",background:C.green,color:C.white,padding:"12px 20px",borderRadius:9,
            fontSize:13,fontWeight:500,textDecoration:"none",fontFamily:FONT_BODY}}>
          💬 Hablar por WhatsApp
        </a>
        <button onClick={onVolver}
          style={{background:"none",border:"none",color:C.stone,fontSize:12,textDecoration:"underline",
            cursor:"pointer",fontFamily:FONT_BODY,padding:"8px 0"}}>
          ← Volver
        </button>
      </div>
    </div>
  );
}

function StepBienvenida({onNext}) {
  return (
    <div>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontSize:36,marginBottom:12}}>🏪</div>
        <h2 style={{fontFamily:FONT_DISPLAY,fontSize:22,fontWeight:400,color:C.carbon,margin:"0 0 8px"}}>
          ¿Es viable este negocio para ti?
        </h2>
        <p style={{fontSize:13,fontWeight:300,color:C.stone,lineHeight:1.6,margin:"0 0 20px"}}>
          En menos de 4 minutos obtendrás un diagnóstico basado en tus números reales — no en los del vendedor.
        </p>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
        {[
          {icon:"💰",title:"Beneficio real",desc:"Cuánto ganarás cada mes con tus números"},
          {icon:"⚖️",title:"¿Precio justo?",desc:"Si lo que te piden está en rango del sector"},
          {icon:"📊",title:"Punto de equilibrio",desc:"Cuánto tienes que vender para no perder dinero"},
        ].map((item,i)=>(
          <div key={i} style={{background:C.cream,border:`1px solid ${C.borderMid}`,borderRadius:10,padding:"14px 12px",textAlign:"center"}}>
            <div style={{fontSize:22,marginBottom:6}}>{item.icon}</div>
            <div style={{fontSize:12,fontWeight:500,color:C.carbon,marginBottom:4,fontFamily:FONT_DISPLAY}}>{item.title}</div>
            <div style={{fontSize:11,color:C.stone,lineHeight:1.3,fontWeight:300}}>{item.desc}</div>
          </div>
        ))}
      </div>

      <div style={{background:C.ocreLight,border:`1px solid ${C.stoneLight}`,borderRadius:10,padding:"12px 16px",marginBottom:20}}>
        <p style={{fontSize:12,color:C.carbon,margin:0,lineHeight:1.6,fontWeight:300}}>
          📋 <strong>Qué necesitas tener a mano:</strong> el precio que te piden, una estimación de lo que crees que puedes vender al mes, y los gastos principales (alquiler, personal, suministros). Con eso es suficiente.
        </p>
      </div>

      <div style={{background:C.cream,border:`1px solid ${C.borderMid}`,borderRadius:10,padding:"10px 14px",marginBottom:20,fontSize:12,color:C.stone,fontWeight:300}}>
        ⏱️ Tiempo estimado: <strong style={{color:C.carbon}}>3–4 minutos</strong> · Los datos que introduces son privados y solo se usan para generar tu diagnóstico.
      </div>

      <Btn onClick={onNext}>Empezar el análisis →</Btn>
    </div>
  );
}

// ─── PASO 1: PERFIL ────────────────────────────────────────────────────────
function StepPerfil({data,setData,onNext,onBack}) {
  const perfiles = [
    {value:"traspaso",icon:"🏪",label:"Voy a comprar un negocio",sub:"Traspaso o negocio en funcionamiento"},
    {value:"emprendedor",icon:"💡",label:"Tengo una idea",sub:"Quiero lanzar algo desde cero"},
    {value:"marcha",icon:"📈",label:"Ya tengo un negocio",sub:"Quiero analizar mis números actuales"},
  ];
  const regimenes = [
    {value:"general",icon:"📄",label:"Régimen general",sub:"Declaro IVA trimestralmente"},
    {value:"recargo",icon:"🏷️",label:"Recargo de equivalencia",sub:"Comercio minorista sin transformación"},
    {value:"modulos",icon:"📐",label:"Módulos",sub:"Pago cuotas fijas a Hacienda"},
  ];
  const ok = data.perfil && data.regimen;
  return (
    <div>
      <h2 style={{fontFamily:FONT_DISPLAY,fontSize:20,fontWeight:400,color:C.carbon,margin:"0 0 4px"}}>¿Cuál es tu situación?</h2>
      <p style={{fontSize:13,color:C.gray600,margin:"0 0 20px",lineHeight:1.5}}>Elige la opción que mejor te describe. Adaptaremos las preguntas a tu caso.</p>

      <Campo label="¿Qué quieres analizar?">
        <SelectCards options={perfiles} value={data.perfil} onChange={v=>setData({...data,perfil:v})}/>
      </Campo>

      {data.perfil&&(
        <div style={{marginBottom:16}}>
          {data.perfil==="traspaso"&&<Alerta tipo="info">Analizaremos si el precio pedido está justificado, cuánto tardarás en recuperar la inversión y si los márgenes son reales.</Alerta>}
          {data.perfil==="emprendedor"&&<Alerta tipo="info">Calcularemos a partir de qué mes empezarás a ganar dinero y cuánto necesitas vender para cubrir costes.</Alerta>}
          {data.perfil==="marcha"&&<Alerta tipo="info">Evaluaremos tus márgenes reales y te diremos qué palancas tienes para mejorar la rentabilidad.</Alerta>}
        </div>
      )}

      {data.perfil==="traspaso"&&(
        <Campo label="¿En qué punto estás?" hint="Opcional — nos ayuda a saber cómo acompañarte mejor">
          <SelectCards
            options={[
              {value:"C1",label:"Estoy explorando",sub:"No tengo nada claro todavía"},
              {value:"C2",label:"Buscando algo",sub:"Sé que quiero un traspaso, no sé cuál"},
              {value:"C3",label:"Ya localizado",sub:"Tengo un negocio concreto en mente"},
            ]}
            value={data.intencion}
            onChange={v=>setData({...data,intencion:v})}
          />
        </Campo>
      )}

      {data.perfil==="emprendedor"&&(
        <Campo label="¿En qué punto estás?" hint="Opcional — nos ayuda a saber cómo acompañarte mejor">
          <SelectCards
            options={[
              {value:"E1",label:"Tengo una idea",sub:"No sé si tirar adelante"},
              {value:"E2",label:"Quiero montar algo",sub:"No he definido el qué"},
              {value:"E3",label:"Plan definido",sub:"Ya sé qué quiero montar"},
            ]}
            value={data.intencion}
            onChange={v=>setData({...data,intencion:v})}
          />
        </Campo>
      )}

      <Campo label="¿Cómo tributas?"
        tooltip="El régimen fiscal afecta a cómo se calculan tus impuestos. Si no lo sabes con seguridad, consulta con tu gestor. La mayoría de autónomos y sociedades están en régimen general.">
        <SelectCards options={regimenes} value={data.regimen} onChange={v=>setData({...data,regimen:v})}/>
      </Campo>

      {data.regimen==="recargo"&&(
        <Alerta tipo="warn">En recargo de equivalencia no declaras IVA, pero tu proveedor te cobra IVA + recargo (ej: 21% + 5,2%) que es un coste real no recuperable. El simulador lo tiene en cuenta en los costes variables.</Alerta>
      )}
      {data.regimen==="modulos"&&(
        <Alerta tipo="info">En módulos pagas cuotas fijas de IVA e IRPF independientemente de tus ventas reales. Introduce tu facturación real para analizar la viabilidad del negocio.</Alerta>
      )}

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8}}>
        <Btn variant="secondary" onClick={onBack}>← Atrás</Btn>
        <Btn onClick={onNext} disabled={!ok}>Continuar →</Btn>
      </div>
    </div>
  );
}

// ─── PASO 2: EL NEGOCIO ────────────────────────────────────────────────────
function StepNegocio({data,setData,onNext,onBack}) {
  const sectores = Object.entries(BENCHMARKS).map(([k,v])=>({value:k,icon:v.icon,label:v.label}));
  const locales = [
    {value:"alquilado",label:"Sí, alquilado",icon:"🔑"},
    {value:"propio",label:"Sí, propio",icon:"🏠"},
    {value:"sin_local",label:"Sin local",icon:"💻"},
  ];
  const empleados = [
    {value:"solo",label:"Solo el dueño",icon:"👤"},
    {value:"1-3",label:"1 – 3",icon:"👥"},
    {value:"4-10",label:"4 – 10",icon:"👨‍👩‍👦"},
    {value:"+10",label:"Más de 10",icon:"🏢"},
  ];
  const ok = data.sector && data.local && data.empleados;
  return (
    <div>
      <h2 style={{fontFamily:FONT_DISPLAY,fontSize:20,fontWeight:400,color:C.carbon,margin:"0 0 4px"}}>El negocio</h2>
      <p style={{fontSize:13,color:C.gray600,margin:"0 0 20px"}}>Cuéntanos qué tipo de negocio {data.perfil==="traspaso"?"estás mirando":"quieres montar o tienes"}.</p>

      <Campo label="¿En qué sector?">
        <SelectCards options={sectores} value={data.sector} onChange={v=>setData({...data,sector:v})} cols={3}/>
      </Campo>
      <Campo label="¿Tiene local físico?">
        <SelectCards options={locales} value={data.local} onChange={v=>setData({...data,local:v})}/>
      </Campo>
      <Campo label="¿Cuántas personas trabajan (incluyendo el dueño)?">
        <SelectCards options={empleados} value={data.empleados} onChange={v=>setData({...data,empleados:v})}/>
      </Campo>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8}}>
        <Btn variant="secondary" onClick={onBack}>← Atrás</Btn>
        <Btn onClick={onNext} disabled={!ok}>Continuar →</Btn>
      </div>
    </div>
  );
}

// ─── PASO 3: INVERSIÓN ─────────────────────────────────────────────────────
function StepInversion({data,setData,onNext,onBack}) {
  const bench = BENCHMARKS[data.sector]||BENCHMARKS.otro;
  const esTraspaso = data.perfil==="traspaso";
  const esEmprendedor = data.perfil==="emprendedor";
  const esMarcha = data.perfil==="marcha";

  const cuota = (() => {
    const P=N(data.prestamo), r=N(data.interes)/100/12, n=N(data.años)*12;
    if(!P) return 0;
    if(!r) return P/n;
    return P*r*Math.pow(1+r,n)/(Math.pow(1+r,n)-1);
  })();

  const totalEntrada = N(data.precio)+N(data.gastos);
  const ok = esMarcha||(esTraspaso&&data.precio)||((esEmprendedor)&&data.inversion)||true;

  return (
    <div>
      <h2 style={{fontFamily:FONT_DISPLAY,fontSize:20,fontWeight:400,color:C.carbon,margin:"0 0 4px"}}>
        {esTraspaso?"Inversión y financiación":esEmprendedor?"Inversión inicial":"Tu retribución"}
      </h2>
      <p style={{fontSize:13,color:C.gray600,margin:"0 0 20px"}}>
        {esTraspaso?"¿Cuánto te piden y cómo vas a financiarlo?":esEmprendedor?"¿Cuánto necesitas invertir para arrancar?":"Introduce lo mínimo que necesitas sacar del negocio mensualmente."}
      </p>

      {esTraspaso&&(
        <>
          <Campo label="¿Cuánto te piden por el negocio?"
            hint={`En ${bench.label.toLowerCase()}, el precio habitual está entre ${fmt(bench.precioRango[0])} y ${fmt(bench.precioRango[1])}`}
            tooltip="Es el precio de traspaso que pide el vendedor, antes de cualquier negociación. Solo el precio del negocio, no incluyas los gastos adicionales.">
            <InputNum value={data.precio} onChange={v=>setData({...data,precio:v})} prefix="€" placeholder="Ej: 65.000"/>
          </Campo>

          <Campo label="Gastos adicionales de entrada"
            tooltip="Además del precio del traspaso, habitualmente hay gastos que tú pagas aparte."
            hint="Suma todo lo que tienes que pagar además del precio del traspaso">
            {/* Desglose orientativo */}
            <div style={{background:C.gray50,border:`1px solid ${C.gray200}`,borderRadius:8,padding:"10px 12px",marginBottom:10,fontSize:11,color:C.gray600,lineHeight:1.6}}>
              <strong style={{color:C.navy,display:"block",marginBottom:4}}>¿Qué suele incluir?</strong>
              🏛️ <strong>Notaría y gestoría:</strong> 500–1.500 € · firma del contrato de traspaso<br/>
              🔑 <strong>Fianza del alquiler:</strong> 1–3 meses de alquiler si asumes el contrato<br/>
              🔧 <strong>Reformas o adaptaciones:</strong> lo que necesites cambiar antes de abrir<br/>
              📋 <strong>Licencias y altas:</strong> apertura, sanitaria, cambio de titularidad<br/>
              📦 <strong>Stock inicial:</strong> mercancía o materiales si no están incluidos<br/>
              🛡️ <strong>Seguros y señales:</strong> primera prima + señal o reserva al vendedor
            </div>
            <InputNum value={data.gastos} onChange={v=>setData({...data,gastos:v})} prefix="€" placeholder="Suma de todos los gastos adicionales"/>
          </Campo>

          {totalEntrada>0&&(
            <Alerta tipo="info">
              💡 Precio real de entrada: <strong>{fmt(totalEntrada)}</strong>. Esta es la cifra que deberías financiar, no solo el precio de traspaso.
            </Alerta>
          )}
        </>
      )}

      {esEmprendedor&&(
        <Campo label="Inversión total para arrancar"
          hint="Suma todo lo que necesitas gastar antes de abrir las puertas"
          tooltip="Incluye: obras y reformas del local, equipamiento y maquinaria, mobiliario, informática, licencias de apertura, stock inicial, gastos de constitución de la empresa y un colchón de tesorería para los primeros meses.">
          <InputNum value={data.inversion} onChange={v=>setData({...data,inversion:v})} prefix="€" placeholder="Ej: 40.000"/>
        </Campo>
      )}

      {!esMarcha&&(
        <div style={{background:C.gray50,border:`1px solid ${C.gray200}`,borderRadius:10,padding:"14px",marginBottom:16}}>
          <p style={{fontSize:12,fontWeight:600,color:C.gray600,margin:"0 0 10px"}}>Financiación</p>
          <Campo label="Dinero propio que aportas" hint="Tus ahorros o aportación de socios. Cuanto más aportes, menos cuota mensual.">
            <InputNum value={data.propio} onChange={v=>setData({...data,propio:v})} prefix="€" placeholder="0"/>
          </Campo>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
            <Campo label="Préstamo" hint="Si necesitas financiación bancaria">
              <InputNum value={data.prestamo} onChange={v=>setData({...data,prestamo:v})} prefix="€" placeholder="0"/>
            </Campo>
            <Campo label="Años">
              <InputNum value={data.años} onChange={v=>setData({...data,años:v})} placeholder="5"/>
            </Campo>
            <Campo label="Interés %">
              <InputNum value={data.interes} onChange={v=>setData({...data,interes:v})} suffix="%" placeholder="5"/>
            </Campo>
          </div>
          {cuota>0&&(
            <Alerta tipo="info">Cuota mensual del préstamo: <strong>{fmt(cuota)}/mes</strong> — se suma automáticamente a tus costes fijos.</Alerta>
          )}
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8}}>
        <Btn variant="secondary" onClick={onBack}>← Atrás</Btn>
        <Btn onClick={onNext} disabled={!ok}>Continuar →</Btn>
      </div>
    </div>
  );
}

// ─── PASO 4: INGRESOS Y COSTES ─────────────────────────────────────────────
function StepIngresosCostes({data,setData,onNext,onBack}) {
  const bench = BENCHMARKS[data.sector]||BENCHMARKS.otro;
  const esTraspaso = data.perfil==="traspaso";
  const esRecargo = data.regimen==="recargo";

  // Gestión de líneas de ingreso
  const addLinea = () => {
    if(data.lineasIngreso.length>=5) return;
    setData({...data,lineasIngreso:[...data.lineasIngreso,{id:Date.now(),nombre:`Línea ${data.lineasIngreso.length+1}`,importe:""}]});
  };
  const removeLinea = id => {
    if(data.lineasIngreso.length<=1) return;
    setData({...data,lineasIngreso:data.lineasIngreso.filter(l=>l.id!==id)});
  };
  const updLinea = (id,campo,val) => {
    setData({...data,lineasIngreso:data.lineasIngreso.map(l=>l.id===id?{...l,[campo]:val}:l)});
  };

  const totalIngresos = data.lineasIngreso.reduce((s,l)=>s+N(l.importe),0);
  const pctVarNum = N(data.pctVar)||bench.variablePct;
  const cvEstimado = totalIngresos*pctVarNum/100;

  const ok = totalIngresos>0;

  return (
    <div>
      <h2 style={{fontFamily:FONT_DISPLAY,fontSize:20,fontWeight:400,color:C.carbon,margin:"0 0 4px"}}>Ingresos y costes</h2>
      <p style={{fontSize:13,color:C.gray600,margin:"0 0 4px"}}>
        {esTraspaso?"Usa tus propias estimaciones — no los datos del vendedor. Sé conservador.":"Introduce tus estimaciones mensuales."}
      </p>
      <p style={{fontSize:11,color:C.stoneLight,margin:"0 0 16px"}}>
        <span style={{color:C.red}}>*</span> Campo obligatorio — el resto son opcionales, pero cuantos más completes, más preciso será tu resultado.
      </p>

      {/* Aviso IVA */}
      <Alerta tipo="info">
        ℹ️ <strong>Introduce todos los importes sin IVA</strong> (base imponible).
        {esRecargo?" En recargo de equivalencia no repercutes IVA a tus clientes — introduce lo que cobras.":" Si tu cliente paga 121 €, introduce 100 €. El IVA no es un ingreso tuyo."}
      </Alerta>

      {/* Referencia sectorial */}
      <div style={{background:C.ocreLight,border:`1px solid ${C.stoneLight}`,borderRadius:10,padding:"10px 14px",marginBottom:16}}>
        <p style={{fontSize:11,fontWeight:600,color:C.navy,margin:"0 0 3px"}}>📊 Referencia del sector — {bench.label}</p>
        <p style={{fontSize:11,color:C.navyLight,margin:0}}>
          Margen bruto habitual: <strong>{bench.margenBruto[0]}–{bench.margenBruto[1]}%</strong> · Coste variable típico: <strong>{bench.variablePct}%</strong> de las ventas
        </p>
      </div>

      {/* INGRESOS */}
      <div style={{marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <label style={{fontSize:13,fontWeight:600,color:C.gray800}}>Ingresos mensuales estimados <span style={{color:C.red}}>*</span></label>
          {data.lineasIngreso.length<5&&(
            <button onClick={addLinea}
              style={{fontSize:11,color:C.navyLight,background:"none",border:`1px solid ${C.navyLight}`,
                borderRadius:6,padding:"3px 10px",cursor:"pointer",fontFamily:"inherit"}}>
              + Añadir línea
            </button>
          )}
        </div>
        <p style={{fontSize:11,color:C.gray500,margin:"0 0 8px",lineHeight:1.4}}>
          Separa por líneas si tienes varias fuentes de ingreso (ej: barra, comidas, eventos). Introduce el importe mensual medio sin IVA.
        </p>
        {data.lineasIngreso.map((l,i)=>(
          <div key={l.id} style={{display:"grid",gridTemplateColumns:"1fr 140px auto",gap:8,marginBottom:8,alignItems:"center"}}>
            <input value={l.nombre} onChange={e=>updLinea(l.id,"nombre",e.target.value)}
              placeholder={`Línea de ingreso ${i+1}`}
              style={{border:`1.5px solid ${C.gray200}`,borderRadius:8,padding:"9px 11px",
                fontSize:13,color:C.gray800,fontFamily:"inherit",outline:"none"}}
              onFocus={e=>e.target.style.borderColor=C.ocre}
              onBlur={e=>e.target.style.borderColor=C.gray200}/>
            <InputNum value={l.importe} onChange={v=>updLinea(l.id,"importe",v)} prefix="€" placeholder="0"/>
            {data.lineasIngreso.length>1&&(
              <button onClick={()=>removeLinea(l.id)}
                style={{background:C.redLight,border:`1px solid ${C.red}`,borderRadius:7,
                  padding:"9px 10px",cursor:"pointer",fontSize:13,color:C.red}}>✕</button>
            )}
          </div>
        ))}
        {totalIngresos>0&&(
          <div style={{background:C.greenLight,border:`1px solid ${C.green}`,borderRadius:8,
            padding:"7px 12px",fontSize:12,color:C.greenDark,fontWeight:600,
            display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span>Total ingresos/mes: <strong>{fmt(totalIngresos)}</strong></span>
            <span style={{color:C.green,opacity:0.8}}>= {fmt(totalIngresos*12)}/año</span>
          </div>
        )}
      </div>

      {/* COSTES VARIABLES */}
      <div style={{background:C.gray50,border:`1px solid ${C.gray200}`,borderRadius:10,padding:"14px",marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
          <label style={{fontSize:13,fontWeight:600,color:C.gray800}}>Costes variables</label>
          <span style={{fontSize:11,background:C.navyLight,color:C.white,padding:"2px 8px",borderRadius:10}}>
            {pctVarNum}% de las ventas = {fmt(cvEstimado)}/mes
          </span>
        </div>
        <p style={{fontSize:11,color:C.gray500,margin:"0 0 10px",lineHeight:1.4}}>
          {bench.descripcionVar}
        </p>
        {esRecargo&&(
          <Alerta tipo="warn">
            En recargo de equivalencia, el coste real de tu mercancía incluye IVA + recargo que pagas al proveedor y que no recuperas. Asegúrate de incluirlo en el porcentaje.
          </Alerta>
        )}
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{flex:1}}>
            <input type="range" min="0" max="90" step="1"
              value={pctVarNum}
              onChange={e=>setData({...data,pctVar:e.target.value})}
              style={{width:"100%",accentColor:C.navy}}/>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:C.gray400,marginTop:2}}>
              <span>0% (servicio puro)</span>
              <span>90% (margen muy bajo)</span>
            </div>
          </div>
          <div style={{width:80}}>
            <InputNum value={data.pctVar||bench.variablePct} onChange={v=>setData({...data,pctVar:v})} suffix="%"/>
          </div>
        </div>
        <p style={{fontSize:10,color:C.gray400,margin:"6px 0 0"}}>
          Referencia del sector: {bench.variablePct}% · Ajusta si conoces tu coste real de mercancía o producción.
        </p>
      </div>

      {/* COSTES FIJOS */}
      <div style={{marginBottom:8}}>
        <label style={{fontSize:13,fontWeight:600,color:C.gray800,display:"block",marginBottom:4}}>Costes fijos</label>
        <p style={{fontSize:11,color:C.gray500,margin:"0 0 10px",lineHeight:1.4}}>Son los gastos que pagas aunque no vendas nada. Introduce importes sin IVA.</p>
      </div>

      {/* Mensuales */}
      <p style={{fontSize:11,fontWeight:600,color:C.ocreDark,margin:"0 0 8px",textTransform:"uppercase",letterSpacing:0.5}}>
        📅 Pagos mensuales
      </p>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
        <Campo label="Alquiler del local"
          hint={data.local==="sin_local"?"Sin local físico, pon 0":"Renta mensual sin IVA"}
          tooltip="El IVA del alquiler (21%) lo pagas al casero pero en régimen general lo deduces trimestralmente. Introduce solo la base sin IVA.">
          <InputNum value={data.alquiler} onChange={v=>setData({...data,alquiler:v})} prefix="€" placeholder="0"/>
        </Campo>
        <Campo label="Personal (coste empresa)"
          hint="Nóminas + Seguridad Social de todos los empleados"
          tooltip="El coste real de un empleado incluye su salario bruto más la Seguridad Social que paga la empresa (aprox. 30%). Ej: si gana 1.000 € brutos, el coste para ti es aprox. 1.300 €/mes.">
          <InputNum value={data.personal} onChange={v=>setData({...data,personal:v})} prefix="€" placeholder="0"/>
        </Campo>
        <Campo label="Suministros"
          hint="Luz, agua, gas, internet, teléfono — mensual"
          tooltip="Suma todos los suministros del local: electricidad, agua, gas, internet y teléfono. Sin IVA. Si no tienes los recibos a mano, estima el total mensual.">
          <InputNum value={data.suministros} onChange={v=>setData({...data,suministros:v})} prefix="€" placeholder="0"/>
        </Campo>
        <Campo label="Gestoría"
          hint="Cuota mensual de contabilidad y declaraciones"
          tooltip="Lo que pagas cada mes a tu gestor por llevar la contabilidad, preparar declaraciones de IVA e IRPF y gestionar nóminas.">
          <InputNum value={data.gestoria} onChange={v=>setData({...data,gestoria:v})} prefix="€" placeholder="0"/>
        </Campo>
        <Campo label="Otros gastos fijos mensuales"
          hint="Marketing, suscripciones, mantenimiento, limpieza..."
          tooltip="Cualquier gasto recurrente que no encaje en las categorías anteriores: cuotas de software, servicio de mantenimiento, limpieza, publicidad recurrente, etc.">
          <InputNum value={data.otrosFijos} onChange={v=>setData({...data,otrosFijos:v})} prefix="€" placeholder="0"/>
        </Campo>
      </div>

      {/* Anuales — convertidos a mensual automáticamente */}
      <p style={{fontSize:11,fontWeight:600,color:C.ocreDark,margin:"0 0 4px",textTransform:"uppercase",letterSpacing:0.5}}>
        📆 Pagos anuales <span style={{fontSize:10,fontWeight:400,color:C.gray400,textTransform:"none"}}>— el simulador los divide entre 12 para el cálculo mensual</span>
      </p>
      <p style={{fontSize:11,color:C.gray500,margin:"0 0 8px",lineHeight:1.4}}>
        Introduce el importe total anual. Ej: si tu seguro cuesta 600 €/año, pon 600.
      </p>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
        <Campo label="Seguros (importe anual)"
          hint="Seguro del local, responsabilidad civil, etc."
          tooltip="Incluye el seguro multirriesgo del local, responsabilidad civil, y cualquier otro seguro del negocio. Los seguros se pagan normalmente una vez al año o en semestres. Introduce el total anual y el simulador lo prorratea. Los seguros no llevan IVA.">
          <div style={{position:"relative"}}>
            <InputNum value={data.segurosAnual} onChange={v=>setData({...data,segurosAnual:v})} prefix="€" placeholder="Ej: 600"/>
            {N(data.segurosAnual)>0&&(
              <p style={{fontSize:10,color:C.greenDark,margin:"3px 0 0",fontWeight:600}}>
                = {fmt(N(data.segurosAnual)/12)}/mes
              </p>
            )}
          </div>
        </Campo>
        <Campo label="Otros gastos anuales"
          hint="Licencias, renovaciones, inspecciones, formación..."
          tooltip="Gastos que se pagan una o dos veces al año: renovación de licencias de actividad, inspecciones técnicas, tasas municipales, cursos de formación obligatoria, cuotas de asociaciones empresariales, etc. Introduce el total anual.">
          <div style={{position:"relative"}}>
            <InputNum value={data.otrosAnual} onChange={v=>setData({...data,otrosAnual:v})} prefix="€" placeholder="Ej: 400"/>
            {N(data.otrosAnual)>0&&(
              <p style={{fontSize:10,color:C.greenDark,margin:"3px 0 0",fontWeight:600}}>
                = {fmt(N(data.otrosAnual)/12)}/mes
              </p>
            )}
          </div>
        </Campo>
      </div>

      {/* RETRIBUCIÓN Y CUOTA */}
      <div style={{background:C.ocreLight,border:`1px solid ${C.stoneLight}`,borderRadius:10,padding:"14px",marginBottom:16}}>
        <p style={{fontFamily:FONT_DISPLAY,fontSize:14,fontWeight:400,color:C.carbon,margin:"0 0 10px"}}>Tu retribución como dueño</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <Campo label="¿Cuánto necesitas sacar tú al mes?"
            tooltip="Es lo mínimo que necesitas para cubrir tus gastos personales. No es un bonus — es un coste fijo del negocio. Si no lo incluyes, el análisis no refleja la realidad.">
            <InputNum value={data.retribucion} onChange={v=>setData({...data,retribucion:v})} prefix="€" placeholder="Ej: 1.200"/>
          </Campo>
          <Campo label="Cuota de autónomos (RETA)"
            hint="Tu cuota mensual a la Seguridad Social"
            tooltip="Como autónomo pagas una cuota mensual a la Seguridad Social, que varía según tus ingresos reales. Si tienes una bonificación o tarifa reducida, pon el importe que realmente pagas tú.">
            <InputNum value={data.cuotaAutonomo} onChange={v=>setData({...data,cuotaAutonomo:v})} prefix="€" placeholder="Ej: 320"/>
          </Campo>
        </div>
      </div>

      {esTraspaso&&(
        <div style={{marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
            <label style={{fontSize:13,fontWeight:600,color:C.gray800}}>Facturación que dice el vendedor</label>
            <span style={{fontSize:10,color:C.gray400}}>(opcional)</span>
          </div>
          <p style={{fontSize:11,color:C.gray500,margin:"0 0 8px",lineHeight:1.4}}>
            Para comparar con tu estimación. ¿Es la cifra mensual o anual que te ha dado?
          </p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:6}}>
            <InputNum value={data.ingresosMesVendedor} onChange={v=>setData({...data,ingresosMesVendedor:v})} prefix="€" placeholder="Cifra del vendedor"/>
            <select value={data.periodoVendedor||"mes"}
              onChange={e=>setData({...data,periodoVendedor:e.target.value})}
              style={{border:`1.5px solid ${C.gray200}`,borderRadius:8,padding:"9px 12px",
                fontSize:13,color:C.gray800,fontFamily:"inherit",outline:"none",background:C.white}}>
              <option value="mes">Mensual</option>
              <option value="año">Anual</option>
            </select>
          </div>
          {N(data.ingresosMesVendedor)>0&&totalIngresos>0&&(()=>{
            const vendMes = data.periodoVendedor==="año"
              ? N(data.ingresosMesVendedor)/12
              : N(data.ingresosMesVendedor);
            const diff = (vendMes-totalIngresos)/vendMes;
            const esGrande = Math.abs(diff)>0.2;
            return (
              <div style={{fontSize:11,color:esGrande?"#991B1B":C.greenDark,fontWeight:600,lineHeight:1.5}}>
                {vendMes>totalIngresos
                  ?`⚠️ Tu estimación (${fmt(totalIngresos)}/mes) es un ${fmtPct(diff*100)} inferior a lo que dice el vendedor (${fmt(vendMes)}/mes). ${esGrande?"Diferencia significativa — pregunta por qué antes de firmar.":"El análisis usa tu estimación."}`
                  :`✅ Tu estimación (${fmt(totalIngresos)}/mes) es similar a lo que dice el vendedor (${fmt(vendMes)}/mes).`}
                {esGrande&&(
                  <a href={urlWhatsapp(`Hola, mi estimación de ventas es de ${fmt(totalIngresos)}/mes y la del vendedor es de ${fmt(vendMes)}/mes (con bastante diferencia). ¿Me podéis ayudar a interpretarlo?`)}
                    target="_blank" rel="noopener noreferrer"
                    style={{display:"block",color:C.ocreDark,marginTop:4,textDecoration:"underline"}}>
                    ¿Necesitas ayuda para interpretarlo? Habla con Relayable →
                  </a>
                )}
              </div>
            );
          })()}
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8}}>
        <Btn variant="secondary" onClick={onBack}>← Atrás</Btn>
        <Btn onClick={onNext} disabled={!ok}>Ver mi diagnóstico →</Btn>
      </div>
    </div>
  );
}

// ─── PASO 5: REGISTRO ──────────────────────────────────────────────────────
function validarEmail(email) {
  if (!email) return null; // vacío no es error, solo ausencia
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email.trim()) ? true : false;
}

function validarTelefono(tel) {
  if (!tel) return null;
  const limpio = tel.replace(/[\s\-()]/g, "");
  const regex = /^(\+?\d{1,3})?\d{9}$/;
  return regex.test(limpio) ? true : false;
}

function StepRegistro({data,setData,onNext,onBack}) {
  const [enviando,setEnviando] = useState(false);
  const [tocado,setTocado] = useState({});

  const emailOk = validarEmail(data.email);
  const telOk = validarTelefono(data.telefono);
  const tieneContacto = (data.email && emailOk) || (data.telefono && telOk);
  const ok = data.nombre && tieneContacto && data.legal;

  const mostrarErrorEmail = tocado.email && data.email && emailOk===false;
  const mostrarErrorTel = tocado.telefono && data.telefono && telOk===false;
  const mostrarAvisoContacto = tocado.email!==undefined || tocado.telefono!==undefined
    ? !tieneContacto && (data.email || data.telefono ? false : true)
    : false;

  const handleVerDiagnostico = async () => {
    setEnviando(true);
    const result = calcular(data);
    await enviarLead("viabilidad", {
      ...data,
      evento: "registro",
      intencion: data.intencion || "no_especificado",
      beneficioMes: Math.round(result.beneficioMes),
    });
    setEnviando(false);
    onNext();
  };

  const inputStyle = (error) => ({
    width:"100%",padding:"10px 12px",border:`1.5px solid ${error?C.red:C.gray200}`,borderRadius:8,
    fontSize:14,color:C.gray800,outline:"none",boxSizing:"border-box",fontFamily:"inherit"
  });

  return (
    <div>
      <h2 style={{fontFamily:FONT_DISPLAY,fontSize:20,fontWeight:400,color:C.carbon,margin:"0 0 4px"}}>Ya casi está</h2>
      <p style={{fontSize:13,color:C.gray600,margin:"0 0 16px",lineHeight:1.5}}>Tu diagnóstico está listo. Déjanos tu email o tu teléfono para verlo y recibir una copia.</p>

      <div style={{background:C.greenLight,border:`1px solid ${C.green}`,borderRadius:10,padding:"12px 14px",marginBottom:16}}>
        <p style={{fontSize:12,color:C.greenDark,margin:0,lineHeight:1.5}}>
          🔒 Tus datos son privados. Solo los usamos para enviarte el diagnóstico y no los compartimos con terceros.
        </p>
      </div>

      <Campo label="Tu nombre">
        <input value={data.nombre||""} onChange={e=>setData({...data,nombre:e.target.value})}
          placeholder="Nombre y apellidos"
          style={inputStyle(false)}
          onFocus={e=>e.target.style.borderColor=C.ocre}
          onBlur={e=>e.target.style.borderColor=C.gray200}/>
      </Campo>

      <Campo label="Email" hint="Déjanos al menos uno: email o teléfono">
        <input type="email" value={data.email||""}
          onChange={e=>setData({...data,email:e.target.value})}
          onBlur={()=>setTocado(t=>({...t,email:true}))}
          placeholder="tu@email.com"
          style={inputStyle(mostrarErrorEmail)}
          onFocus={e=>e.target.style.borderColor=C.ocre}/>
        {mostrarErrorEmail&&(
          <p style={{fontSize:11,color:C.red,margin:"4px 0 0"}}>Revisa el formato del email — falta una @ o un dominio (ej: .com)</p>
        )}
      </Campo>

      <Campo label="Teléfono">
        <input type="tel" value={data.telefono||""}
          onChange={e=>setData({...data,telefono:e.target.value})}
          onBlur={()=>setTocado(t=>({...t,telefono:true}))}
          placeholder="600 000 000"
          style={inputStyle(mostrarErrorTel)}
          onFocus={e=>e.target.style.borderColor=C.ocre}/>
        {mostrarErrorTel&&(
          <p style={{fontSize:11,color:C.red,margin:"4px 0 0"}}>Revisa el número — debe tener 9 dígitos (puedes incluir el prefijo +34)</p>
        )}
      </Campo>

      {(tocado.email||tocado.telefono)&&!tieneContacto&&!mostrarErrorEmail&&!mostrarErrorTel&&(
        <div style={{background:C.amberLight,border:`1px solid ${C.amber}`,borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12,color:C.ocreDark}}>
          Necesitamos al menos un email o un teléfono válido para enviarte el diagnóstico.
        </div>
      )}

      <div style={{display:"flex",alignItems:"flex-start",gap:10,marginBottom:16,marginTop:4}}>
        <input type="checkbox" id="legal" checked={!!data.legal} onChange={e=>setData({...data,legal:e.target.checked})}
          style={{marginTop:2,accentColor:C.navy,width:15,height:15,flexShrink:0}}/>
        <label htmlFor="legal" style={{fontSize:12,color:C.gray600,lineHeight:1.5,cursor:"pointer"}}>
          Acepto la <a href={URL_PRIVACIDAD} target="_blank" rel="noopener noreferrer"
            onClick={e=>e.stopPropagation()}
            style={{color:C.ocreDark,textDecoration:"underline"}}>política de privacidad</a> y recibir comunicaciones de Relayable relacionadas con mi análisis.
        </label>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
        <Btn variant="secondary" onClick={onBack} disabled={enviando}>← Atrás</Btn>
        <Btn onClick={handleVerDiagnostico} disabled={!ok||enviando}>
          {enviando?"Guardando...":"Ver mi diagnóstico →"}
        </Btn>
      </div>
    </div>
  );
}


// ─── DIAGNÓSTICO ───────────────────────────────────────────────────────────

// ─── TEXTOS DEL CTA FINAL POR NIVEL DE INTENCIÓN ──────────────────────────
const CTA_TEXTOS = {
  traspaso: {
    C1: {titulo:"¿Quieres conocer si un traspaso puede ser para ti?",
         sub:"Decidir esto sin acompañamiento da vértigo. Conocemos cientos de historias como la tuya — déjanos ayudarte a ver el camino con claridad.",
         placeholder:"Por ejemplo: en qué sector estás pensando, tu presupuesto, tu zona...",
         boton:"Quiero saber si es para mí →"},
    C2: {titulo:"¿Quieres que te ayudemos a encontrar un negocio rentable?",
         sub:"Buscar a ciegas cansa y hace perder tiempo. Nosotros conocemos el mercado — ponemos ese conocimiento a tu servicio para que encuentres lo que realmente merece la pena.",
         placeholder:"Cuéntanos qué tipo de negocio buscas, presupuesto, zona, sector...",
         boton:"Quiero que me ayudéis a encontrarlo →"},
    C3: {titulo:"¿Quieres que te ayudemos para que el traspaso sea un éxito?",
         sub:"Has llegado hasta aquí por algo. No dejes que un detalle mal revisado eche por tierra una buena decisión — estamos contigo en la recta final.",
         placeholder:"Cuéntanos sobre el negocio que tienes localizado...",
         boton:"Quiero avanzar con este negocio →"},
    no_especificado: {titulo:"¿Quieres que te ayudemos a dar el siguiente paso?",
         sub:"Sea lo que sea lo que tengas en mente, no hace falta tenerlo todo resuelto para empezar a verlo juntos.",
         placeholder:"Escribe aquí lo que necesites contarnos...",
         boton:"Quiero dar el siguiente paso →"},
  },
  emprendedor: {
    E1: {titulo:"Tengo una idea pero no sé si tirar adelante",
         sub:"Toda gran decisión empieza con una duda razonable. No te lances a ciegas — déjanos ayudarte a ver si tu idea es sólida antes de dar el paso.",
         placeholder:"Cuéntanos brevemente en qué consiste tu idea...",
         boton:"Quiero validar mi idea →"},
    E2: {titulo:"Quiero montar algo, pero no he definido el qué",
         sub:"Tener las ganas pero no el rumbo es más común de lo que crees. Conocemos negocios que funcionan en tu zona — quizás uno de ellos sea justo lo que buscas.",
         placeholder:"Cuéntanos tus intereses, presupuesto, zona...",
         boton:"Quiero explorar opciones →"},
    E3: {titulo:"Ya tengo el plan bastante definido",
         sub:"Has hecho el trabajo duro de pensarlo. Ahora toca que los números aguanten la realidad — te ayudamos a blindar tu plan antes de invertir un euro.",
         placeholder:"Cuéntanos brevemente tu plan...",
         boton:"Quiero validar mi plan →"},
    no_especificado: {titulo:"¿Quieres que te ayudemos a dar el siguiente paso?",
         sub:"Sea lo que sea lo que tengas en mente, no hace falta tenerlo todo resuelto para empezar a verlo juntos.",
         placeholder:"Escribe aquí lo que necesites contarnos...",
         boton:"Quiero dar el siguiente paso →"},
  },
  marcha: {
    unico: {titulo:"¿Quieres una mirada externa sobre tu negocio?",
         sub:"Llevar un negocio no deja tiempo para mirarlo desde fuera. Nosotros sí podemos — y a veces ese punto de vista es lo que marca la diferencia entre estancarse y crecer.",
         placeholder:"Cuéntanos qué te gustaría revisar o mejorar...",
         boton:"Quiero una mirada externa →"},
  },
};

function obtenerCtaTextos(perfil, intencion) {
  if (perfil==="marcha") return CTA_TEXTOS.marcha.unico;
  const grupo = perfil==="emprendedor" ? CTA_TEXTOS.emprendedor : CTA_TEXTOS.traspaso;
  return grupo[intencion] || grupo.no_especificado;
}

function StepDiagnostico({data,setData,onModificar,onNuevo}) {
  const [animating,setAnimating] = useState(true);
  useState(()=>{ setTimeout(()=>setAnimating(false),1800); },[]);
  const [solicitando,setSolicitando] = useState(false);
  const [solicitado,setSolicitado] = useState(false);

  const result = calcular(data);
  const {bench} = result;
  const colorSem = result.semaforo==="verde"?C.green:result.semaforo==="ambar"?C.amber:C.red;
  const ctaTextos = obtenerCtaTextos(data.perfil, data.intencion);

  const handleSolicitarPlanCompleto = async () => {
    if (solicitando || solicitado) return; // evita doble envío por doble clic
    setSolicitando(true);
    await enviarLead("viabilidad", {
      ...data,
      evento: "plan_completo",
      intencion: data.intencion || "no_especificado",
      beneficioMes: Math.round(result.beneficioMes),
    });
    setSolicitando(false);
    setSolicitado(true);
  };

  return (
    <div>
      <h2 style={{fontFamily:FONT_DISPLAY,fontSize:19,fontWeight:400,color:C.carbon,margin:"0 0 2px"}}>Tu diagnóstico de viabilidad</h2>
      <p style={{fontSize:12,color:C.gray400,margin:"0 0 4px"}}>Basado en tus estimaciones · {new Date().toLocaleDateString("es-ES")}</p>
      {data.id_registro&&(
        <p style={{fontSize:10,color:C.stoneLight,margin:"0 0 12px",fontFamily:"monospace"}}>
          Referencia: {data.id_registro}
        </p>
      )}

      <Semaforo estado={result.semaforo} animating={animating}/>

      {!animating&&(
        <>
          {/* Razones */}
          <div style={{background:`${colorSem}11`,border:`1px solid ${colorSem}44`,borderRadius:10,padding:"12px 14px",margin:"14px 0"}}>
            {result.razones.map((r,i)=>(
              <p key={i} style={{fontSize:13,color:C.gray800,margin:i>0?"6px 0 0":0,lineHeight:1.5}}>
                {result.semaforo==="verde"?"✅":result.semaforo==="ambar"?"⚠️":"❌"} {r}
              </p>
            ))}
          </div>

          {/* Métricas principales */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:14}}>
            <MetricCard label="Beneficio mensual estimado" value={fmt(result.beneficioMes)}
              highlight={result.beneficioMes>0} color={result.beneficioMes<0?C.red:undefined}/>
            <MetricCard label="Margen bruto" value={fmtPct(result.margenBruto)}
              sub={`Sector: ${bench.margenBruto[0]}–${bench.margenBruto[1]}%`}/>
            <MetricCard label="Margen neto" value={fmtPct(result.margenNeto)}
              sub="Referencia: >5% saludable"/>
          </div>

          {/* Punto de equilibrio explicado */}
          <div style={{background:C.gray50,border:`1px solid ${C.gray200}`,borderRadius:10,padding:"12px 14px",marginBottom:14}}>
            <p style={{fontFamily:FONT_DISPLAY,fontSize:14,fontWeight:400,color:C.carbon,margin:"0 0 8px"}}>📊 Punto de equilibrio</p>
            <p style={{fontSize:12,color:C.gray600,margin:"0 0 6px",lineHeight:1.5}}>
              Necesitas facturar al menos <strong style={{color:C.navy}}>{fmt(result.puntoEq)}/mes</strong> para no perder dinero.
            </p>
            {result.ing>0&&(
              <p style={{fontSize:12,color:result.margenSeguridad>0?C.greenDark:C.red,margin:0,fontWeight:600}}>
                {result.margenSeguridad>0
                  ?`✅ Estás ${fmt(result.margenSeguridad)}/mes por encima del punto de equilibrio — margen de seguridad del ${fmtPct(result.margenSeguridad/result.ing*100)}.`
                  :`❌ Estás ${fmt(Math.abs(result.margenSeguridad))}/mes por debajo. Necesitas aumentar ventas o reducir costes.`}
              </p>
            )}
          </div>

          {/* Escenarios */}
          <p style={{fontFamily:FONT_DISPLAY,fontSize:14,fontWeight:400,color:C.carbon,margin:"0 0 8px"}}>Análisis de escenarios</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:14}}>
            <MetricCard label="Escenario pesimista (−20% ventas)"
              value={fmt(result.pesimista.ben)}
              color={result.pesimista.ben<0?C.red:C.greenDark}
              sub={result.pesimista.ben<0?"⚠️ Pérdidas":"✅ Rentable"}/>
            <MetricCard label="Escenario base" value={fmt(result.beneficioMes)}
              highlight={result.beneficioMes>0} sub="Con tus estimaciones actuales"/>
            <MetricCard label="Escenario optimista (+20% ventas)"
              value={fmt(result.optimista.ben)}
              color={C.greenDark} sub="✅ Potencial de mejora"/>
          </div>

          {/* Traspaso: recuperación */}
          {data.perfil==="traspaso"&&(N(data.precio)||N(data.gastos))>0&&(
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
              <MetricCard label="Recuperación de la inversión" value={fmtMes(result.mesesRec)}
                sub={`Inversión total: ${fmt(N(data.precio)+N(data.gastos))}`}
                color={result.mesesRec>48?C.red:result.mesesRec>30?C.amber:C.greenDark}/>
              <MetricCard label="Múltiplo de valoración" value={result.multiplo>0?`${result.multiplo.toFixed(1)}x`:"—"}
                sub={`Rango sector: ${bench.multiplo[0]}–${bench.multiplo[1]}x`}
                color={result.multiplo>bench.multiplo[1]?C.red:C.greenDark}/>
            </div>
          )}

          {/* Alertas del sector */}
          {bench.alertas.length>0&&(
            <div style={{background:C.amberLight,border:`1px solid ${C.amber}`,borderRadius:10,padding:"12px 14px",marginBottom:16}}>
              <p style={{fontFamily:FONT_DISPLAY,fontSize:14,fontWeight:400,color:C.ocreDark,margin:"0 0 8px"}}>⚠️ Puntos clave a verificar — {bench.label}</p>
              {bench.alertas.map((a,i)=>(
                <p key={i} style={{fontSize:12,color:"#78350F",margin:i>0?"5px 0 0":0,lineHeight:1.5}}>· {a}</p>
              ))}
            </div>
          )}

          {/* Botones modificar / nuevo — se bloquean tras enviar la solicitud */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16}}>
            <Btn variant="secondary" onClick={onModificar} small disabled={solicitado}>✏️ Modificar mis datos</Btn>
            <Btn variant="secondary" onClick={onNuevo} small disabled={solicitado}>🔄 Nuevo análisis</Btn>
          </div>
          {solicitado&&(
            <p style={{fontSize:10,color:C.stoneLight,textAlign:"center",margin:"-10px 0 16px",fontWeight:300}}>
              Ya hemos recibido tu solicitud — si necesitas cambiar algo, escríbenos directamente.
            </p>
          )}

          {/* CTA upgrade — texto dinámico según perfil + nivel de intención */}
          <div style={{background:C.carbon,borderRadius:14,padding:"22px"}}>
            <p style={{fontFamily:FONT_DISPLAY,fontSize:17,fontWeight:400,color:C.white,margin:"0 0 6px"}}>
              {ctaTextos.titulo}
            </p>
            <p style={{fontSize:12,color:C.stoneLight,margin:"0 0 16px",lineHeight:1.6,fontWeight:300}}>
              {ctaTextos.sub}
            </p>
            <div style={{display:"grid",gridTemplateColumns:"1fr",gap:8}}>
              {!solicitado&&(
                <>
                  <label style={{fontSize:11,color:"#D4A843",fontWeight:500,marginBottom:-4}}>
                    Cuéntanos más, si quieres
                  </label>
                  <textarea
                    value={data.comentario||""}
                    onChange={e=>{
                      if(e.target.value.length<=600) setData({...data,comentario:e.target.value});
                    }}
                    placeholder={ctaTextos.placeholder}
                    rows={2}
                    style={{width:"100%",background:"#26231F",border:"1px solid rgba(255,255,255,0.15)",
                      borderRadius:8,padding:"9px 11px",fontSize:12,color:C.white,fontFamily:FONT_BODY,
                      resize:"none",outline:"none",boxSizing:"border-box"}}
                  />
                  <p style={{fontSize:10,color:"#5F5E5A",textAlign:"right",margin:"-4px 0 4px"}}>
                    {(data.comentario||"").length} / 600
                  </p>
                </>
              )}
              <button onClick={handleSolicitarPlanCompleto} disabled={solicitando||solicitado}
                style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                  background:solicitado?C.green:C.ocre,color:C.white,padding:"13px 20px",borderRadius:9,border:"none",
                  fontSize:14,fontWeight:500,fontFamily:FONT_BODY,cursor:(solicitando||solicitado)?"not-allowed":"pointer",
                  opacity:solicitando?0.7:1}}>
                {solicitando?"Enviando...":solicitado?"✓ Solicitud enviada":ctaTextos.boton}
              </button>
              {solicitado&&(
                <p style={{fontSize:11,color:C.greenLight,textAlign:"center",margin:"0 0 4px",fontWeight:300,lineHeight:1.5}}>
                  Hemos recibido tu solicitud — te contactaremos en menos de 24h.<br/>
                  Referencia: <span style={{fontFamily:"monospace"}}>{data.id_registro}</span>
                </p>
              )}
              <a href={urlWhatsapp(`Hola, he hecho el simulador de viabilidad${data.negocio?` para "${data.negocio}"`:""} y quiero más información sobre el plan completo`)}
                target="_blank" rel="noopener noreferrer"
                style={{display:"block",textAlign:"center",fontSize:12,color:C.white,
                  textDecoration:"none",padding:"8px 0",fontFamily:FONT_BODY,fontWeight:500}}>
                💬 o hablar ahora por WhatsApp
              </a>
              <a href={WEB_CONTACTO} target="_blank" rel="noopener noreferrer"
                style={{display:"block",textAlign:"center",fontSize:11,color:C.stoneLight,
                  textDecoration:"underline",padding:"2px 0",fontFamily:FONT_BODY}}>
                o escríbenos por el formulario de contacto
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ─── SIMULADOR PRINCIPAL ───────────────────────────────────────────────────
// Genera un ID único al iniciar el wizard — se mantiene igual durante toda
// la sesión, para que "registro" y "plan_completo" comparta el mismo ID
// y se puedan localizar juntos en la hoja de cálculo.
function generarIdRegistro() {
  const ahora = new Date();
  const fecha = ahora.toISOString().slice(0,10).replace(/-/g,"");
  const hora = ahora.toISOString().slice(11,19).replace(/:/g,"");
  const random = Math.floor(Math.random()*900+100);
  return `REL-${fecha}-${hora}-${random}`;
}

const initData = () => ({
  id_registro: generarIdRegistro(),
  perfil:"", regimen:"general", sector:"", local:"", empleados:"",
  intencion:"",
  precio:"", gastos:"", inversion:"", propio:"", prestamo:"", años:"5", interes:"5",
  retribucion:"", cuotaAutonomo:"", alquiler:"", personal:"", suministros:"",
  gestoria:"", otrosFijos:"",
  segurosAnual:"", otrosAnual:"",
  pctVar:"",
  lineasIngreso:[{id:1,nombre:"Ingresos principales",importe:""}],
  ingresosMesVendedor:"", periodoVendedor:"mes",
  nombre:"", email:"", telefono:"", legal:false,
  comentario:"",
});

export default function SimuladorRelayable() {
  // Entrada directa al wizard de comprador/emprendedor — ya no se
  // muestra la landing de bifurcación "comprador/vendedor" porque la
  // web dirige tráfico con enlaces específicos por tipo de usuario
  // (relayable.es/simulador-de-viabilidad ya es inequívocamente de
  // comprador). El componente StepLanding se mantiene en el código por
  // si se necesita reutilizar como entrada genérica en el futuro.
  // "vendedor_proximamente" = aviso si elige vendedor antes de que esté listo (ya no se usa por la misma razón)
  // 0-6 = flujo del wizard de viabilidad (comprador)
  const [vista,setVista] = useState("wizard");
  const [step,setStep] = useState(0);
  const [data,setData] = useState(initData());
  const topRef = useRef(null);
  const TOTAL = 6; // 0=bienvenida 1=perfil 2=negocio 3=inversion 4=ingresos 5=registro 6=diagnostico

  const scrollTop = () => setTimeout(()=>topRef.current?.scrollIntoView({behavior:"smooth"}),50);
  const next = () => { setStep(s=>Math.min(s+1,TOTAL)); scrollTop(); };
  const back = () => { setStep(s=>Math.max(s-1,0)); scrollTop(); };
  const goTo = (n) => { setStep(n); scrollTop(); };

  const handleElegir = (tipo) => {
    if (tipo==="comprador") { setVista("wizard"); setStep(0); scrollTop(); }
    else { window.location.href = "/calculadora-de-valoracion"; }
  };

  const steps = [
    <StepBienvenida onNext={next}/>,
    <StepPerfil data={data} setData={setData} onNext={next} onBack={back}/>,
    <StepNegocio data={data} setData={setData} onNext={next} onBack={back}/>,
    <StepInversion data={data} setData={setData} onNext={next} onBack={back}/>,
    <StepIngresosCostes data={data} setData={setData} onNext={next} onBack={back}/>,
    <StepRegistro data={data} setData={setData} onNext={next} onBack={back}/>,
    <StepDiagnostico data={data} setData={setData}
      onModificar={()=>goTo(4)}
      onNuevo={()=>{setData(initData());goTo(0);}}/>,
  ];

  return (
    <>
      <CargarFuentes/>
      <div ref={topRef} style={{minHeight:"100vh",background:C.cream,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"24px 16px 48px",fontFamily:FONT_BODY}}>
        <div style={{width:"100%",maxWidth:540,background:C.white,borderRadius:20,boxShadow:"0 4px 28px rgba(28,26,23,0.07)",border:`1px solid ${C.border}`,padding:"28px 28px 24px"}}>

          {/* Logo + volver a la web */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:step>0?20:24}}>
            <span style={{fontFamily:FONT_DISPLAY,fontSize:19,fontWeight:500,color:C.carbon,letterSpacing:0.2}}>
              relay<span style={{color:C.ocre}}>able</span>
            </span>
            {step===0 ? (
              <a href={WEB_HOME} target="_blank" rel="noopener noreferrer"
                style={{fontSize:11,color:C.stone,textDecoration:"none",display:"flex",alignItems:"center",gap:5}}>
                ← Volver a la web
              </a>
            ) : (
              vista==="wizard"&&step>0&&step<6&&
              <span style={{fontSize:11,color:C.stoneLight,background:C.cream,padding:"2px 10px",borderRadius:10}}>
                Simulador de viabilidad
              </span>
            )}
          </div>

          {/* Barra progreso (solo dentro del wizard, pasos 1-5) */}
          {vista==="wizard"&&step>0&&step<6&&<BarraProgreso step={step} total={5}/>}

          {/* Contenido */}
          {vista==="landing"&&<StepLanding onElegir={handleElegir}/>}
          {vista==="vendedor_proximamente"&&<StepVendedorProximamente onVolver={()=>setVista("landing")}/>}
          {vista==="wizard"&&steps[step]}
        </div>
      </div>
    </>
  );
}
